
















	import { MyActions } from '@/models/Store/State';
	import Vue from 'vue';

    export default Vue.extend({
        name: "ListTerminComp",
        props: ['termin'],
        computed: {
            headline: function(): string {
                if (this.termin.no) {
                    return `#${this.termin.no} - ${this.termin.dateString}`;
                } else {
                    return this.termin.dateString;
                }
            },
            subline: function(): string {
                if (this.termin.endtime) {
                    return `${this.termin.time} - ${this.termin.endtime}`;
                } else {
                    return this.termin.time;
                }
            },
            icon: function(): string {
                if (this.termin) {
                    if (this.termin.type === null) return 'warning';
                    const icons = ['check_circle', 'check_circle_outline', 'cancel'];
                    return icons[this.termin.type];
                } else {
                    return '';
                }
            }
        },
        methods: {
            openTermin: function() {
                this.$vStore.dispatch(MyActions.OpenTermin, this.termin);
            }
        }
    })
